<script>
import { Bar } from "vue-chartjs";

export default {
    data() {
        return {
            chart: {
                labels: ["Jan", "Fed", "Mar", "Apr", "May", "Jun"],
                datasets: [
                    {
                        label: "Average Rating",
                        data: [4.9, 2.3, 1.9, 4.3, 4.1, 3.8],
                        backgroundColor: "rgba(255, 99, 132, 1)",
                        borderWidth: 0
                    },
                    {
                        data: [4.9, 2.3, 1.9, 4.3, 4.1, 3.8],
                        backgroundColor: "rgba(0, 0, 0, 0.1)",
                        borderWidth: 0
                    }
                ]
            },
            options: {
                responsive: true,
                aspectRatio: 2.4,
                tooltips: {
                    filter: function(tooltipItem) {
                        return tooltipItem.datasetIndex === 0;
                    }
                },
                legend: {
                    display: false
                },
                scales: {
                    xAxes: [
                        {
                            stacked: true,
                            ticks: {
                                beginAtZero: true
                            },
                            gridLines: {
                                display: false
                            },
                            maxBarThickness: "14"
                        }
                    ],
                    yAxes: [
                        {
                            stacked: true,
                            ticks: {
                                beginAtZero: true
                            },
                            gridLines: {
                                display: false
                            }
                        }
                    ]
                }
            }
        };
    },
    props: ["data", "labels"],
    extends: Bar,
    mounted() {},
    created() {},
    watch: {
        data: function(newValue, oldValue) {
            var shadowData = newValue.map(a => 5 - a);
            this.chart.datasets[0].data = newValue;
            this.chart.datasets[1].data = shadowData;
            this.renderChart(this.chart, this.options);
        },
        labels: function(newValue, oldValue) {
            this.chart.labels = newValue;
            this.renderChart(this.chart, this.options);
        }
    },
    methods: {}
};
</script>
